import { useConcurso } from '../../../../providers/ConcursoProvider';
import { PuestosTable } from '../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestosTable';
import { TablaActoAdministrativo } from './TablaActoAdministrativo';

import { AccordionItem } from '../../../Accordion/AccordionItem';
import { Accordion } from '../../../Accordion/Accordion';
import { Container } from 'react-bootstrap';

const CargaActoAdministrativo = () => {
  const concurso = useConcurso();
  const { idLlamadoConcurso } = concurso;
  return (
    <Container>
      <TablaActoAdministrativo />
      <Accordion>
        <AccordionItem title="Denominaciones cargadas">
          <PuestosTable idLlamadoConcurso={idLlamadoConcurso} withBases />
        </AccordionItem>
      </Accordion>
    </Container>
  );
};

export default CargaActoAdministrativo;
